import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '../../core/core.module';
import { LogInRouteComponent } from './log-in-route.component';
import {MatButtonModule} from '@angular/material/button';


@NgModule({
  declarations: [
    LogInRouteComponent
  ],
  imports: [
    CommonModule,
    CoreModule,
    MatButtonModule
  ],
  exports: [
    LogInRouteComponent
  ]
})
export class LogInRouteModule { }
